export default "__VITE_ASSET__DkKxaz3B__"